import React, { useCallback, useState } from 'react';
import axios from '../redux/sagas/axios';
import { CountriesPrefsSelector } from './countries_prefs_selector';

const Edit = ({ preferences, initialMyPreferences, isApp, isTutorial, countriesPrefs, currentPrefId, circles = [], currentUserId, registeredCircleIds = [] }) => {
  /* ---------- Preferences ---------- */
  const [isSelectedIds, setIsSelectedIds] = useState(
    initialMyPreferences.map((p) => p.id)
  );
  const [myPreferences, setMyPreferences] = useState(initialMyPreferences);
  /* ---------- OshikatsuCircles ---------- */
  const [keyword, setKeyword] = useState('');
  const [matchedCircles, setMatchedCircles] = useState([]);
  const [similarCircles,  setSimilarCircles]  = useState([]);
  const [searching, setSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedCircleIds, setSelectedCircleIds] = useState(registeredCircleIds);
  const allCircles = [...circles, ...matchedCircles, ...similarCircles];
  const noResult = hasSearched && !searching && matchedCircles.length === 0 && similarCircles.length === 0;

  const onChangePreferenceIds = useCallback(
    (preference) => {
      let newIsSelectedIds = isSelectedIds;

      if (isSelectedIds.includes(preference.id)) {
        newIsSelectedIds = isSelectedIds.filter((id) => id !== preference.id);
        setIsSelectedIds(newIsSelectedIds);
        setMyPreferences(myPreferences.filter((p) => p.id !== preference.id));
      } else {
        const newMyPreferences =
          preference.preference_type !== 1
            ? myPreferences.filter(
                (p) => p.preference_type !== preference.preference_type
              )
            : myPreferences;

        newIsSelectedIds = newMyPreferences
          .map((p) => p.id)
          .concat(preference.id);

        setIsSelectedIds(newIsSelectedIds);
        setMyPreferences(newMyPreferences.concat(preference));
      }

      try {
        const preferenceIds = JSON.stringify({
          preference_ids: newIsSelectedIds,
        });
        axios.post('/api/preferences_users', preferenceIds);
      } catch (e) {
        alert('通信に失敗しました。');
      }
    },
    [myPreferences, isSelectedIds]
  );

  const handleSearch = async () => {
    const kw = keyword.trim();
    if (!kw) return;
      setSearching(true);
    try {
      const { data } = await axios.get(
        '/api/oshikatsu/favorites/search_match_oshikatsu_circle',
        { params: { query: kw } });
        setMatchedCircles(data.exact_matches ?? []);
        setSimilarCircles(data.similar_matches ?? []);
    } catch (e) {
      alert('検索に失敗しました');
    } finally {
      setSearching(false);
      setHasSearched(true);
    }
  };

  const handleCircleToggle = useCallback(async (circle) => {
    if (!currentUserId) {
      alert('ログインしてください');
      return;
    }
    const already = selectedCircleIds.includes(circle.id);
  
    setSelectedCircleIds(prev =>
      already ? prev.filter(id => id !== circle.id) : [...prev, circle.id]
    );
  
    try {
      await axios.post(
        already
          ? '/api/oshikatsu/favorites/unfollow_oshikatsu_circle'
          : '/api/oshikatsu/favorites/follow_oshikatsu_circle',
        { circle_id: circle.id },
      );
    } catch (e) {
      setSelectedCircleIds(prev =>
        already ? [...prev, circle.id] : prev.filter((id) => id !== circle.id)
      );
      alert(already ? '解除に失敗しました' : '登録に失敗しました');
    }
  }, [currentUserId, selectedCircleIds]);

  let tmp_preference_type = 0;

  return (
    <div>
      {isApp && isTutorial && (
        <CountriesPrefsSelector countriesPrefs={countriesPrefs} currentPrefId={currentPrefId} />
      )}
      <div className="container col-md-8 col-lg-6 mb-0">
        {preferences.map((preference, index) => {
          const isSelected = isSelectedIds.includes(preference.id);

          if (tmp_preference_type === preference.preference_type) {
            tmp_preference_type = preference.preference_type;
            return (
              <label
                key={index}
                className={`p-2 m-2 text-fz-12px cursor-pointer badge badge-pill ${
                  isSelected
                    ? 'text-white bg-tunagate-gradation'
                    : 'badge-light'
                }`}
              >
                <input
                  type={preference.preference_type != 1 ? 'radio' : 'checkbox'}
                  checked={isSelected}
                  onChange={() => onChangePreferenceIds(preference)}
                  style={{ display: 'none' }}
                />
                {preference.name}
              </label>
            );
          } else {
            tmp_preference_type = preference.preference_type;
            return (
              <span key={index}>
                <h6 className="text-fz-16px text-fw-bold text-left mt-5">
                  {preference.preference_type === 1 ? '"推し"や"好き"を登録しよう（複数選択可）' : preference.description}
                </h6>
                {preference.preference_type === 1 && (
                  <p className="text-fz-12px text-muted mb-2 ml-2">
                    ”好き”を語れる仲間が見つかるかも！?
                  </p>
                )}
                <label
                  className={`p-2 m-2 text-fz-12px cursor-pointer badge badge-pill ${
                    isSelected
                      ? 'text-white bg-tunagate-gradation'
                      : 'badge-light'
                  }`}
                >
                  <input
                    type={
                      preference.preference_type != 1 ? 'radio' : 'checkbox'
                    }
                    checked={isSelected}
                    onChange={() => onChangePreferenceIds(preference)}
                    style={{ display: 'none' }}
                  />
                  {preference.name}
                </label>
              </span>
            );
          }
        })}
      </div>
      <div className="container col-md-8 col-lg-6 mb-5">
        {allCircles.map(circle => {
          const isSelected = selectedCircleIds.includes(circle.id);
          return (
            <span
              key={`circle-${circle.id}`}
              className={`p-2 m-2 text-fz-12px cursor-pointer badge badge-pill ${
                isSelected ? 'text-white bg-tunagate-gradation' : 'badge-light'
              }`}
              onClick={() => handleCircleToggle(circle)}
            >
              {circle.name}
            </span>
          );
        })}
        <p className="text-fz-12px text-muted mb-2 ml-2 mt-3">
          推しや、好きなものを検索してみよう
        </p>
        <div className="w-100 d-flex align-items-center">
          <input
            type="text"
            className="flex-grow-1 form-control bg-light border-0 text-fz-16px py-3"
            placeholder="ミセスグリーンアップル"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            style={{ backgroundColor: '#F5F5F5' }}
          />
          <button className="btn btn-outline-orange ml-3 px-4 text-fz-14px text-nowrap" style={{ borderWidth: 2 }} onClick={handleSearch}>
            検索
          </button>
        </div>
        {searching && (
          <p className="text-fz-14px text-muted mt-2">
            検索中
          </p>
        )}
        {noResult && (
          <p className="text-fz-12px text-muted mt-2">
            該当する名前が見つかりませんでした
          </p>
        )}
      </div>
    </div>
    );
  };
export default Edit;
